import { Typography, IconButton, Icon, Box, Stack } from '@ace-clublabs/shared-component-library';
import { ProductType } from '../../application/models/NewJoinSessionData';
import { PriceInfoCard } from './PriceInfoCard';

interface IAddOn {
  onDelete?: () => void;
  onAdd?: () => void;
  onEdit?: () => void;
  showPrice?: boolean;
  price?: number | { min: number; max: number };
  discountedPrice?: number;
  priceSuffix?: string;
  priceRange?: { min: number; max: number };
  isSelected: boolean;
  text: string;
  icon: string;
  type: ProductType | 'associate' | 'family-upgrade';
  hideAddDeleteIcon?: boolean;
}

export const AddOn = ({
  onDelete,
  onEdit,
  showPrice = true,
  isSelected,
  text,
  price,
  discountedPrice,
  priceSuffix,
  onAdd,
  type,
  hideAddDeleteIcon,
}: IAddOn) => {
  const showEditButton = isSelected && onEdit;
  const containerClassName = `add-${type}-container ${isSelected ? 'benefit-selected' : 'add-benefit-container'}`;
  const editClassName = `edit-${type}`;
  const addClassName = `add-${type}`;
  const removeClassName = `remove-${type}`;

  const isAssociate = type === 'associate';
  const productAdded = (type === ProductType.ERS || type === ProductType.RV) && isSelected;

  return (
    <Stack
      className={containerClassName}
      direction="row"
      sx={{
        marginTop: '1rem',
        cursor: 'pointer',
        background: '#FFF',
        border: isSelected ? 'none' : '1.5px dashed #1976d2',
        borderRadius: '0.5rem',
      }}
      onClick={!isSelected ? onAdd : undefined}
    >
      <Stack className="add-benefit" direction="row" justifyContent="flex-start" alignItems="center" gap="0.5rem">
        <Box sx={{ fontSize: '1.5rem' }} className={'addon-icon'}>
          {isSelected ? (
            <Icon iconName="circle-check-solid" color="primary" className="check-icon" />
          ) : (
            <Icon
              color="primary"
              aria-label={addClassName}
              sx={{ fontSize: '1.25rem', padding: '0 !important' }}
              className={addClassName}
              iconName="plus-regular"
            />
          )}
        </Box>
        <Typography
          data-di-mask={isAssociate ? 'true' : 'false'}
          className="add-on-text qm-mask"
          variant="b1Medium"
          sx={{ color: '#016BCD' }}
        >
          {productAdded ? 'Added' : `${text}`}
        </Typography>
      </Stack>
      <Stack className="add-benefit-details" direction="row" justifyContent="center" alignItems="center" gap="0.5rem">
        {showPrice &&
          price !== undefined &&
          (typeof price === 'number' ? (
            <PriceInfoCard
              originalPrice={price}
              priceAfterDiscount={discountedPrice}
              priceSuffix={priceSuffix}
              className={`${type}-price`}
            />
          ) : (
            <PriceInfoCard
              priceRange={price}
              priceAfterDiscount={discountedPrice}
              priceSuffix={priceSuffix}
              className={`${type}-price`}
            />
          ))}
        {showEditButton ? (
          <IconButton
            aria-label={editClassName}
            onClick={onEdit}
            className={editClassName}
            sx={{ padding: '0 !important', height: '24px', width: '24px' }}
          >
            <Icon iconName="pen-regular" />
          </IconButton>
        ) : (
          <></>
        )}

        {hideAddDeleteIcon ? (
          <></>
        ) : isSelected ? (
          <IconButton
            aria-label={removeClassName}
            onClick={onDelete}
            className={removeClassName}
            sx={{ padding: '0 !important', height: '24px', width: '24px' }}
          >
            <Icon iconName="circle-x-regular" />
          </IconButton>
        ) : (
          <></>
        )}
      </Stack>
    </Stack>
  );
};
